import React from "react";
import useContentFontScale from "../hooks/useContentFontScale";
import Button from "./Button";
import { colors } from "./tokens";

const containerStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  background: colors.topbarSurface,
  border: `1px solid ${colors.topbarSurfaceHover}`,
  borderRadius: "999px",
  padding: "4px 8px",
};

const buttonStyle = {
  border: "none",
  background: "transparent",
  color: colors.chromeText,
  cursor: "pointer",
  padding: "4px 6px",
  borderRadius: "6px",
  fontSize: "12px",
  fontWeight: 600,
  minWidth: "28px",
  boxShadow: "none",
};

const buttonDisabledStyle = {
  opacity: 0.4,
  cursor: "not-allowed",
};

const labelStyle = {
  color: colors.chromeText,
  fontSize: "12px",
  minWidth: "86px",
  textAlign: "center",
};

export default function ContentTextSizeControl() {
  const { label, canDecrease, canIncrease, decrease, increase } = useContentFontScale();

  return (
    <div role="group" aria-label="Content text size" style={containerStyle}>
      <Button
        type="button"
        onClick={decrease}
        disabled={!canDecrease}
        aria-label="Decrease content text size"
        variant="ghost"
        style={{ ...buttonStyle, ...(canDecrease ? null : buttonDisabledStyle) }}
      >
        A-
      </Button>
      <span aria-live="polite" style={labelStyle}>
        {label}
      </span>
      <Button
        type="button"
        onClick={increase}
        disabled={!canIncrease}
        aria-label="Increase content text size"
        variant="ghost"
        style={{ ...buttonStyle, ...(canIncrease ? null : buttonDisabledStyle) }}
      >
        A+
      </Button>
    </div>
  );
}
